import { CSSProperties } from 'react'
import { clsx } from 'modules/Utils'

interface GemIconProps {
    className?: string
    style?: CSSProperties
    color?: string
    size?: number
}

const GemIcon = ({
    className,
    style,
    color = 'gold',
    size = 14
}: GemIconProps) => {
    return (
        <svg
            className={clsx('gemIconComponent', className)}
            style={style}
            width={size}
            height={size}
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                stroke={color}
                strokeLinecap="round"
                strokeWidth="2"
                d="m3.956 11.507 8.172 9.08a.5.5 0 0 0 .744 0l8.172-9.08a1 1 0 0 0 .151-1.117l-2.419-4.837A1 1 0 0 0 17.882 5H7.118a1 1 0 0 0-.894.553l-2.42 4.837a1 1 0 0 0 .152 1.117Z"
                clipRule="evenodd"
            />
            <path
                stroke={color}
                strokeLinecap="round"
                strokeWidth="2"
                d="m9 8.5-.862 1.724a.5.5 0 0 0 .047.523L9.5 12.5"
            />
        </svg>
    )
}

export default GemIcon